// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BSGx","toggle":"styles_toggle__2b4R-","preview":"styles_preview__3SshD"};